export default { "columns":32,
 "image":"tiles16.png",
 "imageheight":512,
 "imagewidth":512,
 "margin":0,
 "name":"tiles16",
 "spacing":0,
 "tilecount":1024,
 "tiledversion":"1.11.2",
 "tileheight":16,
 "tiles":[
        {
         "id":1,
         "type":"decal"
        }, 
        {
         "id":2,
         "type":"decal"
        }, 
        {
         "id":3,
         "type":"decal"
        }, 
        {
         "id":4,
         "type":"decal"
        }, 
        {
         "id":5,
         "type":"decal"
        }, 
        {
         "id":10,
         "type":"decal"
        }, 
        {
         "id":11,
         "type":"decal"
        }, 
        {
         "id":12,
         "type":"decal"
        }, 
        {
         "id":22,
         "type":"decal"
        }, 
        {
         "id":23,
         "type":"decal"
        }, 
        {
         "id":33,
         "type":"ground"
        }, 
        {
         "id":34,
         "type":"ground"
        }, 
        {
         "id":35,
         "type":"ground"
        }, 
        {
         "id":36,
         "type":"ground"
        }, 
        {
         "id":37,
         "type":"ground"
        }, 
        {
         "id":39,
         "type":"decal"
        }, 
        {
         "id":40,
         "type":"decal"
        }, 
        {
         "id":41,
         "type":"ground"
        }, 
        {
         "id":42,
         "type":"ground"
        }, 
        {
         "id":43,
         "type":"ground"
        }, 
        {
         "id":44,
         "type":"ground"
        }, 
        {
         "id":45,
         "type":"ground"
        }, 
        {
         "id":47,
         "type":"decal"
        }, 
        {
         "id":48,
         "type":"decal"
        }, 
        {
         "id":49,
         "type":"platform"
        }, 
        {
         "id":50,
         "type":"platform"
        }, 
        {
         "id":51,
         "type":"platform"
        }, 
        {
         "id":52,
         "type":"platform"
        }, 
        {
         "id":55,
         "type":"decal"
        }, 
        {
         "id":65,
         "type":"ground"
        }, 
        {
         "id":66,
         "type":"ground"
        }, 
        {
         "id":67,
         "type":"ground"
        }, 
        {
         "id":68,
         "type":"ground"
        }, 
        {
         "id":69,
         "type":"ground"
        }, 
        {
         "id":71,
         "type":"decal"
        }, 
        {
         "id":72,
         "type":"decal"
        }, 
        {
         "id":73,
         "type":"ground"
        }, 
        {
         "id":74,
         "type":"ground"
        }, 
        {
         "id":75,
         "type":"ground"
        }, 
        {
         "id":76,
         "type":"ground"
        }, 
        {
         "id":77,
         "type":"ground"
        }, 
        {
         "id":79,
         "type":"decal"
        }, 
        {
         "id":80,
         "type":"decal"
        }, 
        {
         "id":81,
         "type":"platform"
        }, 
        {
         "id":82,
         "type":"platform"
        }, 
        {
         "id":83,
         "type":"platform"
        }, 
        {
         "id":84,
         "type":"platform"
        }, 
        {
         "id":85,
         "type":"platform"
        }, 
        {
         "id":97,
         "type":"ground"
        }, 
        {
         "id":98,
         "type":"ground"
        }, 
        {
         "id":99,
         "type":"ground"
        }, 
        {
         "id":100,
         "type":"ground"
        }, 
        {
         "id":101,
         "type":"ground"
        }, 
        {
         "id":105,
         "type":"ground"
        }, 
        {
         "id":106,
         "type":"ground"
        }, 
        {
         "id":107,
         "type":"ground"
        }, 
        {
         "id":108,
         "type":"ground"
        }, 
        {
         "id":109,
         "type":"ground"
        }, 
        {
         "id":113,
         "type":"decal"
        }, 
        {
         "id":114,
         "type":"decal"
        }, 
        {
         "id":115,
         "type":"decal"
        }, 
        {
         "id":117,
         "type":"decal"
        }, 
        {
         "id":118,
         "type":"decal"
        }, 
        {
         "id":119,
         "type":"decal"
        }, 
        {
         "id":129,
         "type":"ground"
        }, 
        {
         "id":130,
         "type":"ground"
        }, 
        {
         "id":131,
         "type":"ground"
        }, 
        {
         "id":132,
         "type":"ground"
        }, 
        {
         "id":133,
         "type":"ground"
        }, 
        {
         "id":137,
         "type":"ground"
        }, 
        {
         "id":138,
         "type":"ground"
        }, 
        {
         "id":139,
         "type":"ground"
        }, 
        {
         "id":140,
         "type":"ground"
        }, 
        {
         "id":141,
         "type":"ground"
        }, 
        {
         "id":145,
         "type":"decal"
        }, 
        {
         "id":146,
         "type":"decal"
        }, 
        {
         "id":147,
         "type":"decal"
        }, 
        {
         "id":149,
         "type":"decal"
        }, 
        {
         "id":151,
         "type":"decal"
        }, 
        {
         "id":161,
         "type":"ground"
        }, 
        {
         "id":162,
         "type":"ground"
        }, 
        {
         "id":163,
         "type":"ground"
        }, 
        {
         "id":164,
         "type":"ground"
        }, 
        {
         "id":165,
         "type":"ground"
        }, 
        {
         "id":169,
         "type":"ground"
        }, 
        {
         "id":170,
         "type":"ground"
        }, 
        {
         "id":171,
         "type":"ground"
        }, 
        {
         "id":172,
         "type":"ground"
        }, 
        {
         "id":173,
         "type":"ground"
        }, 
        {
         "id":177,
         "type":"decal"
        }, 
        {
         "id":178,
         "type":"decal"
        }, 
        {
         "id":179,
         "type":"decal"
        }, 
        {
         "id":181,
         "type":"decal"
        }, 
        {
         "id":183,
         "type":"decal"
        }, 
        {
         "id":193,
         "type":"decal"
        }, 
        {
         "id":194,
         "type":"decal"
        }, 
        {
         "id":209,
         "type":"decal"
        }, 
        {
         "id":210,
         "type":"decal"
        }, 
        {
         "id":211,
         "type":"decal"
        }, 
        {
         "id":213,
         "type":"decal"
        }, 
        {
         "id":215,
         "type":"decal"
        }, 
        {
         "id":226,
         "type":"decal"
        }, 
        {
         "id":227,
         "type":"decal"
        }, 
        {
         "id":228,
         "type":"decal"
        }, 
        {
         "id":234,
         "type":"decal"
        }, 
        {
         "id":235,
         "type":"decal"
        }, 
        {
         "id":257,
         "type":"ground"
        }, 
        {
         "id":258,
         "type":"ground"
        }, 
        {
         "id":259,
         "type":"ground"
        }, 
        {
         "id":260,
         "type":"ground"
        }, 
        {
         "id":261,
         "type":"ground"
        }, 
        {
         "id":263,
         "type":"decal"
        }, 
        {
         "id":264,
         "type":"decal"
        }, 
        {
         "id":265,
         "type":"ground"
        }, 
        {
         "id":266,
         "type":"ground"
        }, 
        {
         "id":267,
         "type":"ground"
        }, 
        {
         "id":268,
         "type":"ground"
        }, 
        {
         "id":269,
         "type":"ground"
        }, 
        {
         "id":271,
         "type":"decal"
        }, 
        {
         "id":272,
         "type":"decal"
        }, 
        {
         "id":273,
         "type":"ground"
        }, 
        {
         "id":274,
         "type":"ground"
        }, 
        {
         "id":275,
         "type":"ground"
        }, 
        {
         "id":277,
         "type":"decal"
        }, 
        {
         "id":278,
         "type":"decal"
        }, 
        {
         "id":289,
         "type":"ground"
        }, 
        {
         "id":290,
         "type":"ground"
        }, 
        {
         "id":291,
         "type":"ground"
        }, 
        {
         "id":292,
         "type":"ground"
        }, 
        {
         "id":293,
         "type":"ground"
        }, 
        {
         "id":295,
         "type":"decal"
        }, 
        {
         "id":296,
         "type":"decal"
        }, 
        {
         "id":297,
         "type":"ground"
        }, 
        {
         "id":298,
         "type":"ground"
        }, 
        {
         "id":299,
         "type":"ground"
        }, 
        {
         "id":300,
         "type":"ground"
        }, 
        {
         "id":301,
         "type":"ground"
        }, 
        {
         "id":303,
         "type":"decal"
        }, 
        {
         "id":304,
         "type":"decal"
        }, 
        {
         "id":305,
         "type":"ground"
        }, 
        {
         "id":306,
         "type":"ground"
        }, 
        {
         "id":307,
         "type":"ground"
        }, 
        {
         "id":320,
         "type":"decal"
        }, 
        {
         "id":321,
         "type":"ground"
        }, 
        {
         "id":322,
         "type":"ground"
        }, 
        {
         "id":323,
         "type":"ground"
        }, 
        {
         "id":324,
         "type":"ground"
        }, 
        {
         "id":325,
         "type":"ground"
        }, 
        {
         "id":326,
         "type":"decal"
        }, 
        {
         "id":329,
         "type":"ground"
        }, 
        {
         "id":330,
         "type":"ground"
        }, 
        {
         "id":331,
         "type":"ground"
        }, 
        {
         "id":332,
         "type":"ground"
        }, 
        {
         "id":333,
         "type":"ground"
        }, 
        {
         "id":337,
         "type":"ground"
        }, 
        {
         "id":338,
         "type":"ground"
        }, 
        {
         "id":342,
         "type":"decal"
        }, 
        {
         "id":353,
         "type":"ground"
        }, 
        {
         "id":354,
         "type":"ground"
        }, 
        {
         "id":355,
         "type":"ground"
        }, 
        {
         "id":356,
         "type":"ground"
        }, 
        {
         "id":357,
         "type":"ground"
        }, 
        {
         "id":361,
         "type":"ground"
        }, 
        {
         "id":362,
         "type":"ground"
        }, 
        {
         "id":363,
         "type":"ground"
        }, 
        {
         "id":364,
         "type":"ground"
        }, 
        {
         "id":365,
         "type":"ground"
        }, 
        {
         "id":374,
         "type":"decal"
        }, 
        {
         "id":385,
         "type":"ground"
        }, 
        {
         "id":386,
         "type":"ground"
        }, 
        {
         "id":387,
         "type":"ground"
        }, 
        {
         "id":388,
         "type":"ground"
        }, 
        {
         "id":389,
         "type":"ground"
        }, 
        {
         "id":393,
         "type":"ground"
        }, 
        {
         "id":394,
         "type":"ground"
        }, 
        {
         "id":395,
         "type":"ground"
        }, 
        {
         "id":396,
         "type":"ground"
        }, 
        {
         "id":397,
         "type":"ground"
        }, 
        {
         "id":401,
         "objectgroup":
            {
             "draworder":"index",
             "id":3,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":6,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":2,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":402,
         "type":"decal"
        }, 
        {
         "id":403,
         "type":"decal"
        }, 
        {
         "id":404,
         "type":"decal"
        }, 
        {
         "id":418,
         "type":"decal"
        }, 
        {
         "id":419,
         "type":"decal"
        }, 
        {
         "id":420,
         "type":"decal"
        }, 
        {
         "id":433,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":2,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":450,
         "type":"decal"
        }, 
        {
         "id":451,
         "type":"decal"
        }, 
        {
         "id":465,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":2,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":467,
         "type":"decal"
        }, 
        {
         "id":468,
         "type":"decal"
        }, 
        {
         "id":469,
         "type":"decal"
        }, 
        {
         "id":481,
         "type":"ground"
        }, 
        {
         "id":482,
         "type":"ground"
        }, 
        {
         "id":483,
         "type":"ground"
        }, 
        {
         "id":484,
         "type":"ground"
        }, 
        {
         "id":485,
         "type":"ground"
        }, 
        {
         "id":487,
         "type":"decal"
        }, 
        {
         "id":488,
         "type":"decal"
        }, 
        {
         "id":489,
         "type":"ground"
        }, 
        {
         "id":490,
         "type":"ground"
        }, 
        {
         "id":491,
         "type":"ground"
        }, 
        {
         "id":492,
         "type":"ground"
        }, 
        {
         "id":493,
         "type":"ground"
        }, 
        {
         "id":495,
         "type":"decal"
        }, 
        {
         "id":496,
         "type":"decal"
        }, 
        {
         "id":499,
         "type":"decal"
        }, 
        {
         "id":500,
         "type":"decal"
        }, 
        {
         "id":501,
         "type":"decal"
        }, 
        {
         "id":513,
         "type":"ground"
        }, 
        {
         "id":514,
         "type":"ground"
        }, 
        {
         "id":515,
         "type":"ground"
        }, 
        {
         "id":516,
         "type":"ground"
        }, 
        {
         "id":517,
         "type":"ground"
        }, 
        {
         "id":519,
         "type":"decal"
        }, 
        {
         "id":520,
         "type":"decal"
        }, 
        {
         "id":521,
         "type":"ground"
        }, 
        {
         "id":522,
         "type":"ground"
        }, 
        {
         "id":523,
         "type":"ground"
        }, 
        {
         "id":524,
         "type":"ground"
        }, 
        {
         "id":525,
         "type":"ground"
        }, 
        {
         "id":527,
         "type":"decal"
        }, 
        {
         "id":528,
         "type":"decal"
        }, 
        {
         "id":545,
         "type":"ground"
        }, 
        {
         "id":546,
         "type":"ground"
        }, 
        {
         "id":547,
         "type":"ground"
        }, 
        {
         "id":548,
         "type":"ground"
        }, 
        {
         "id":549,
         "type":"ground"
        }, 
        {
         "id":553,
         "type":"ground"
        }, 
        {
         "id":554,
         "type":"ground"
        }, 
        {
         "id":555,
         "type":"ground"
        }, 
        {
         "id":556,
         "type":"ground"
        }, 
        {
         "id":557,
         "type":"ground"
        }, 
        {
         "id":561,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagleft"
        }, 
        {
         "id":562,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagright"
        }, 
        {
         "id":577,
         "type":"ground"
        }, 
        {
         "id":578,
         "type":"ground"
        }, 
        {
         "id":579,
         "type":"ground"
        }, 
        {
         "id":580,
         "type":"ground"
        }, 
        {
         "id":581,
         "type":"ground"
        }, 
        {
         "id":585,
         "type":"ground"
        }, 
        {
         "id":586,
         "type":"ground"
        }, 
        {
         "id":587,
         "type":"ground"
        }, 
        {
         "id":588,
         "type":"ground"
        }, 
        {
         "id":589,
         "type":"ground"
        }, 
        {
         "id":593,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":594,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":609,
         "type":"ground"
        }, 
        {
         "id":610,
         "type":"ground"
        }, 
        {
         "id":611,
         "type":"ground"
        }, 
        {
         "id":612,
         "type":"ground"
        }, 
        {
         "id":613,
         "type":"ground"
        }, 
        {
         "id":617,
         "type":"ground"
        }, 
        {
         "id":618,
         "type":"ground"
        }, 
        {
         "id":619,
         "type":"ground"
        }, 
        {
         "id":620,
         "type":"ground"
        }, 
        {
         "id":621,
         "type":"ground"
        }, 
        {
         "id":642,
         "type":"decal"
        }, 
        {
         "id":643,
         "type":"decal"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};